import React from 'react';

export default class Redirect extends React.Component {

  componentDidMount() {
  	window.location = this.props.url;
  }

  render() {
    if (this.props.hideMessage){
      // Sometimes we don't want a message to flash when redirecting
      return <div />
    }
    return (
      <div>
      	Please wait while we redirect you to: {this.props.url}
      </div>
    );
  }

};